var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.existeDatos)?_c(_vm.componenteGrafica(_vm.tipo),{tag:"component",attrs:{"labels":_vm.datos_grafica.labels,"dataset":_vm.datos_grafica.dataset,"opciones":_vm.datos_grafica.opciones}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }